<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__contact">
        <div class="footer__address">
          <span class="footer__label">地址</span>
          <p>江苏省南京市江宁区东麒路33号</p>
        </div>
        <div class="footer__email">
          <span class="footer__label">联系我们</span>
          <p>384489962@qq.com</p>
        </div>
      </div>
      <div class="footer__qrcodes">
        <div class="footer__qr-item">
          <img src="../assets/img/official.jpg" alt="公众号" />
          <p>公众号</p>
        </div>
        <div class="footer__qr-item">
          <img src="../assets/img/video.jpg" alt="视频号" />
          <p>视频号</p>
        </div>
      </div>
    </div>
    <div class="footer__bottom">
      &copy; {{ year }} 依睿迪亚（南京）智能科技有限公司 版权所有
    </div>
  </footer>
</template>

<script>
import { computed } from "vue";

export default {
  setup() {
    const year = computed(() => new Date().getFullYear());
    return {
      year,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.footer {
  background: $color-primary-dark;
  color: $color-text-white;
  padding-top: $space-lg;

  &__inner {
    width: $container-width;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: $space-md;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  }

  &__contact {
    display: flex;
    flex-direction: column;
    gap: $space-sm;
  }

  &__label {
    display: block;
    font-size: $font-size-small;
    color: $color-highlight;
    font-weight: 600;
    letter-spacing: 0.08em;
    margin-bottom: 2px;
  }

  &__address p,
  &__email p {
    font-size: $font-size-body;
    color: rgba(255, 255, 255, 0.85);
  }

  &__qrcodes {
    display: flex;
    gap: $space-lg;
  }

  &__qr-item {
    text-align: center;
    img {
      width: 1rem;
      height: 1rem;
      border-radius: $radius-sm;
      border: 2px solid rgba(255, 255, 255, 0.2);
      transition: border-color $transition-base;
    }
    p {
      font-size: $font-size-small;
      margin-top: $space-xs;
      color: rgba(255, 255, 255, 0.7);
    }

    &:hover img {
      border-color: $color-accent;
    }
  }

  &__bottom {
    width: $container-width;
    margin: 0 auto;
    padding: $space-md 0;
    font-size: $font-size-small;
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
  }
}
</style>
